import ApiGusData from 'types/api/GusData';

export default class GusData {
    companyName: string;
    address: string;
    street: string;
    propertyNumber: string;
    apartmentNumber: string;
    city: string;
    postalCode: string;
    country: string;

    constructor(data: ApiGusData) {
        this.companyName = data.companyName;
        this.address = data.address;
        this.city = data.city;
        this.postalCode = data.postalCode;
        this.country = data.country;
    }
}